import { useState } from "react";
import AgTechSideNavigationAppLogo from "./AgTechSideNavigationAppLogo";
import AgTechSideNavigationCollapseIcon from "./AgTechSideNavigationCollapseIcon";
import AgTechSideNavigationHelpButton from "./AgTechSideNavigationHelpButton";
import { AgTechWebApplicationInfo } from "../../../../../../application/AgTechWebApplication";
import { AgTechTourConfig } from "../../../../../../components/App/Tour/AgTechTourTypes";

export type SideNavigationProps = {
    app: AgTechWebApplicationInfo,
    width?: string,
    tourConfig?: AgTechTourConfig,
    content: (isCollapsed: boolean) => React.ReactNode
};

const AgTechSideNavigationMenu = (props: SideNavigationProps) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const width = isCollapsed ? 'w-[72px]' : props.width ?? 'w-[240px]';

    return (
        <div
            className={`tall row-based relative transition-[width] duration-300 ease ${width} flex`}
        >
            <AgTechSideNavigationAppLogo
                appIcon={props.app.icon}
                appName={props.app.name}
                isCollapsed={isCollapsed}
            />
            <div className="row-based flex-1 flex">
                {props.content(isCollapsed)}
                {props.tourConfig && (
                    <AgTechSideNavigationHelpButton
                        tourConfig={props.tourConfig}
                        isCollapsed={isCollapsed}
                    />
                )}
                <AgTechSideNavigationCollapseIcon
                    isCollapsed={isCollapsed}
                    toggleCollapsed={() => setIsCollapsed(!isCollapsed)}
                />
            </div>
        </div>
    )
}

export default AgTechSideNavigationMenu;